import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, TS_Input } from '@nu-art/thunderstorm-frontend';
import { Component_SearchAddOn } from '../../components/Component_SearchAddOn.js';
import { AddOn_SearchTerm } from './types.js';
import './Component_AddOn_SearchTerm.scss';
import { TS_Icons } from '@nu-art/ts-styles';
export class Component_AddOn_SearchTerm extends Component_SearchAddOn {
    deriveStateFromProps(nextProps, state) {
        state.placeholder = nextProps.placeholder;
        return state;
    }
    addOn = AddOn_SearchTerm;
    render() {
        return _jsxs(LL_H_C, { className: 'search-add-on__search-term', children: [_jsx(TS_Input, { type: 'text', value: this.state.value, placeholder: this.state.placeholder, onChange: val => this.setValue(val.trimStart()) }), _jsx(TS_Icons.Search.component, {})] });
    }
}
//# sourceMappingURL=Component_AddOn_SearchTerm.js.map